module.exports = __webpack_public_path__ + "static/labour&birth-e624ccaae8fd60e580bec8e05b6f3bef.png";